import { render, staticRenderFns } from "./StudyPlanReminderCard.vue?vue&type=template&id=0888eec9&scoped=true"
import script from "./StudyPlanReminderCard.vue?vue&type=script&lang=js"
export * from "./StudyPlanReminderCard.vue?vue&type=script&lang=js"
import style0 from "./StudyPlanReminderCard.vue?vue&type=style&index=0&id=0888eec9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0888eec9",
  null
  
)

export default component.exports